<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17_17)">
      <g clip-path="url(#clip1_17_17)">
        <path
          d="M6.07189 3.984L23.9999 0L41.9279 3.984C42.4124 4.0917 42.8457 4.36138 43.1563 4.74852C43.4669 5.13566 43.6362 5.61713 43.6363 6.11345V27.9033C43.6361 30.0583 43.1039 32.18 42.0869 34.08C41.0699 35.98 39.5996 37.5996 37.8064 38.7949L23.9999 48L10.1933 38.7949C8.40049 37.5998 6.93035 35.9806 5.91338 34.081C4.8964 32.1814 4.36404 30.0601 4.36353 27.9055V6.11345C4.36361 5.61713 4.53292 5.13566 4.8435 4.74852C5.15409 4.36138 5.58739 4.0917 6.07189 3.984Z"
          fill="#F8F8F8"
        />
        <path
          d="M6.07189 3.984L23.9999 0L41.9279 3.984C42.4124 4.0917 42.8457 4.36138 43.1563 4.74852C43.4669 5.13566 43.6362 5.61713 43.6363 6.11345V27.9033C43.6361 30.0583 43.1039 32.18 42.0869 34.08C41.0699 35.98 39.5996 37.5996 37.8064 38.7949L23.9999 48L10.1933 38.7949C8.40049 37.5998 6.93035 35.9806 5.91338 34.081C4.8964 32.1814 4.36404 30.0601 4.36353 27.9055V6.11345C4.36361 5.61713 4.53292 5.13566 4.8435 4.74852C5.15409 4.36138 5.58739 4.0917 6.07189 3.984ZM8.72716 7.86327V27.9033C8.72719 29.3399 9.08187 30.7543 9.75973 32.021C10.4376 33.2877 11.4177 34.3674 12.613 35.1644L23.9999 42.7571L35.3868 35.1644C36.5818 34.3676 37.5617 33.2882 38.2395 32.022C38.9174 30.7557 39.2722 29.3417 39.2726 27.9055V7.86327L23.9999 4.47273L8.72716 7.86327Z"
          fill="#EBEBEB"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_17_17">
        <rect
          width="48"
          height="48"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_17_17">
        <rect
          width="39.2727"
          height="48"
          fill="white"
          transform="translate(4.36353)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
